import { BaseText } from '@/components/base'
import { StickyHeaderNavigation } from '@/components/StickyHeaderNavigation'
import { BaseView } from '@/components/base'
import { useTranslation } from 'react-i18next'

const RecoverPasswordWithPhoneHeader = () => {
  const { t } = useTranslation()
  // TODO: add back button text?
  return (
    <BaseView gap={20}>
      <StickyHeaderNavigation />

      <BaseText fontSize={32} fontFamily="semibold">
        {t('screens:forgotPassword.title', {
          method: t('form:actions.phoneNumber'),
        })}
      </BaseText>
    </BaseView>
  )
}

export default RecoverPasswordWithPhoneHeader
